import http from './http'
export const generateConversation = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `/podcastai/content`
    })
}
export const generatePodcastAudio = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `/podcastai/tts`
    })
}
export const createVoice = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `/podcastai/voices`
    })
}
export const deleteVoice = (payload) => {
    return http({
        method: 'DELETE',
        data: payload,
        url: `/podcastai/voices`
    })
}
export const getAllVoices = () => {
    return http({
        method: 'GET',
        url: `/podcastai/voices`
    })
}
export const newPodcastGenerate = (payload) => {
    return http({
        method: 'POST',
        data: payload,
        url: `https://shl-ai.dev.sharelookapp.link/?service=podcast`,
    })
}
export const getAllMusic = () => {
    return http({
        method: 'GET',
        url: `/library?isMusic=true`
    })
}

export const checkPodcastStatus = (id) => {
    return http({
        method: 'GET',
        url: `library/${id}/info`
    })
}